// @flow
import environment from '../../../../environment';
import { postCreator } from '../../../../http';

export const endpoints = Object.freeze({
  POST_POSITIVE_FEEDBACK: `${environment.apiUrl}/purchase/:orderId/feedback/positive`,
  POST_NEGATIVE_FEEDBACK: `${environment.apiUrl}/purchase/:orderId/feedback/negative`,
  POST_FEEDBACK: `${environment.apiUrl}/purchase/:orderId/review`,
});

export const postPositiveFeedbackApi = postCreator(fetch, endpoints.POST_POSITIVE_FEEDBACK);
export const postNegativeFeedbackApi = postCreator(fetch, endpoints.POST_NEGATIVE_FEEDBACK);
export const postFeedbackApi = postCreator(fetch, endpoints.POST_FEEDBACK);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/feedback/api.js